import React from 'react';
import {Panel, Accordion} from 'react-bootstrap';
import '../../../styles/establishment/establishmentHeader.css';
import InfoIcon from '../../icons/InfoIcon';

const EstablishmentsDashboardHeading = () => {
  return (
  <div>
    <div id="establishment-dashboard-header">
      <div
        id="establishment-dashboard-instructions-container"
        className="alert alert-info col-xs-12 non-mobile">
        <div id="establishment-dashboard-instructions">
          <div className="first-line"><InfoIcon/> Instructions for Adding and Submitting Your 300A Data to OSHA</div>
          <ul>
            <li>
              To add or edit 300A data for an establishment, select its name in the list below.</li>
            <li>
              To submit data to OSHA, select one or more establishments from the list below by checking the box on the left-hand side, then select <em>Submit Data for Selected</em> button.  Note: This only applies to establishments in the "Not Submitted" status.</li>
          </ul>
        </div>
      </div>
      <Accordion defaultActiveKey="1">
        <Panel
          header="Instructions for Finalizing and Submitting Your Data to OSHA"
          eventKey="1"
          id="establishment-dashboard-instructions-container"
          className="alert alert-info col-xs-12 mobile">
          <div id="establishment-dashboard-instructions">
            <ul>
              <li>
                Select one or more establishments from the list below, then click Submit button</li>
              <li>
                If you have more than one page of establishments, you may select establishments
                from multiple pages before clicking the submit button.</li>
              <li>
                To edit 300A data for an establishment, click its name in the list below.
              </li>
            </ul>
          </div>
        </Panel>
      </Accordion>
    </div>
  </div>
  );
};

export default EstablishmentsDashboardHeading;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/establishmentsDashboard/EstablishmentsDashboardHeading.js
 **/